import { inject } from 'mobx-react'
import React from 'react'
import { Query } from 'react-apollo'
import { Redirect, RouteComponentProps, withRouter } from 'react-router-dom'
import Loader from '../../common/loader/Loader'
import { i18n } from '../index'
import { fetchMe } from './authQueries'
import { AuthStore, User } from './types'

type PersistUserProps = {
  authStore: AuthStore
  user: User
}

function ErrorMessage() {
  return <div>{i18n.t('tokenPage.errorFetchingUserMessage')}</div>
}

function PersistUser({ user, authStore }: PersistUserProps) {
  if (!user) {
    return <ErrorMessage />
  }
  authStore.setUser(user)
  return <Redirect to='/' />
}

type InjectedProps = {
  authStore: AuthStore
}

const TokenPage = inject('authStore')((props: RouteComponentProps & InjectedProps) => {
  const { authStore } = props

  return (
    <Query<{ me: User }, {}> query={fetchMe}>
      {({ loading, error, data }) => (
        <Loader loading={loading} error={error}>
          <PersistUser user={data.me} authStore={authStore} />
        </Loader>
      )}
    </Query>
  )
})

export default withRouter(TokenPage)
